import { useContext } from 'react';
import { DrawerContext } from 'context/drawer';

const useDrawerContext = () => {
  return useContext(DrawerContext);
};

export default useDrawerContext;
